// API configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8787';

// API endpoints
export const ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh'
  },
  APPLICATIONS: {
    LIST: '/applications',
    CREATE: '/applications',
    CLIENT_APP: '/client-applications'
  },
  CLIENTS: {
    LIST: '/clients',
    CREATE: '/clients',
    UPDATE: (id) => `/clients/${id}`,
    DELETE: (id) => `/clients/${id}`
  },
  TASKS: {
    EXECUTE: (taskId) => `/tasks/${taskId}/execute`
  },
  DEPLOYMENTS: {
    LIST: '/deployments',
    CREATE: '/deployments',
    GET: (id) => `/deployments/${id}`,
    TRIGGER: (id) => `/deployments/${id}`,
    DOWNLOAD_ARTIFACT: (id) => `/deployments/${id}/mobile/artifact`,
    DELETE: (id) => `/deployments/${id}`
  },
}; 